import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import update from 'immutability-helper';
import Field from 'components/Form/Field';
import Delete  from '../Buttons/Delete';

import * as actions from '../../data/categories/actions';

class BrandChannelEditor extends React.Component {

  state = {
    value: {
    }
  };

  componentWillReceiveProps = (e) => {
    this.setState({
      value: e.value,
    });
  }

  componentWillMount() {
    this.props.fetchCategories();
  }

  static contextTypes = {
    router: PropTypes.object
  };


  handleChannelDeleteClick = (id) => {

    const next = update(this.state, { 
      value: { 
        [id]: {$set:undefined}}
    });
    delete next.value[id];

    this.setState(next);
  }

  handleChannelEditClick = (key, k, v) => {
    this.context.router.history.push("/admin/brand/"+this.props.brandid +"/"+key);
  }

  handleAddChannel = () => {

    var id = "id"+(new Date().valueOf());
    var newgroup = { value: { [id]: {name:'', categoryid:''}}};
    var next = _.merge({}, this.state, newgroup);
    this.setState(next );
    
  }

  handleChannelNameChange = (key, field) => {

    const next = update(this.state, { 
      value: { 
        [key]: {
          name: {$set: field.state.value}
        }
      }
    });
    this.setState(next);
    
  }


  handleChannelTypeChange = (key, event, index, value) => {
    const next = update(this.state, { 
      value: { 
        [key]: {
          categoryid: {$set: value}
        }
      }
    });
    this.setState(next);
  }

  
  

  
  renderChannels = () => {
    return _.map(this.state.value, (target, key) => {
      return (
        <div key={key} className="brandchanneleditor__group">
          <div className="brandchanneleditor__details">
            <Field handleChange={this.handleChannelNameChange.bind(this,key)} value={target.name} floatingLabelText="Kanalnamn"/>
            

            <SelectField floatingLabelText="Kanaltyp" value={target.categoryid} onChange={this.handleChannelTypeChange.bind(this, key)} >
              {_.map(this.props.categorytypes, (opt, key) => <MenuItem key={key} value={key} primaryText={opt.name} />  ) }      
            </SelectField>

            <RaisedButton primary={true} label="Redigera" onTouchTap={this.handleChannelEditClick.bind(this, key)} />

            <RaisedButton secondary={true} label="Radera" onTouchTap={this.handleChannelDeleteClick.bind(this, key)} />
          </div>
          
        </div>
      );
    });
  }


  render() {
    return (
      <div className="brandchanneleditor">
      {this.renderChannels()}
      <RaisedButton primary={true} label="Lägg till ny kanal" onClick={this.handleAddChannel} />
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {

  return {
    categorytypes: state.categories.list.data
  };
}

export default connect(mapStateToProps, actions, null, {withRef:true})(BrandChannelEditor)

  



// WEBPACK FOOTER //
// ./src/components/Form/BrandChannelEditor.jsx